import FilterForm from './FilterForm';

export default FilterForm;
